module.exports = __webpack_public_path__ + "media/images/admin/anim-drag-move-3895113890d3979882396e34ce3e3552.webp";